import axios from 'axios';
import qs from 'qs';
import Cookies from 'js-cookie';
import { getDomain, getQuery } from '@/utils/location';
import { Notification } from 'element-react';
import { createBrowserHistory } from 'history';
import { getUuid } from '@/utils/uuid';
import encryptSign from '@/utils/encryptSign';
import encryptSignWithdraw from '@/utils/encryptSignWithdraw';
import { getMainDomain } from '@/utils/utils';
import models from './models';
import device from '@/utils/device';
import { getDeviceInfoHeader } from '@/utils/deviceInfo';

const proUrlArrays = [
  '/attr/t/wallet/getTransferCoins',
  '/attr/a/coins/mon',
  '/pro/p/quotation/q/agg-ticker', // TODO:
  '/attr/t/lm/order/createOrder',
  '/attr/t/lm/order/getTradeList',
  '/attr/t/lm/order/getOrderByOrderId', // TODO:
  '/attr/t/lm/order/getHistoryOrders',
  '/attr/t/lm/order/getOrders',
  '/attr/t/recharge/address',
  '/attr/t/withdraw/address/getAddressList',
  '/attr/t/withdraw/address/add',
  '/attr/t/mail/getList', // 站内信列表
  '/attr/t/mail/readZnxMessage',
  '/attr/t/mail/push/alert/preference',
  '/attr/t/price-alert/create',
  '/attr/t/price-alert/update',
  '/attr/t/price-alert/getList',
  '/attr/t/withdraw/address/delete',
  '/attr/t/withdraw/address/update',
  '/attr/t/withdraw/create',
  '/attr/t/withdraw/cancelRecords', // TODO: 取消提现
  '/attr/t/wallet/getWalletType',
  '/pro/deposit/u/withdraw/coin/record', // TODO:
  '/attr/t/withdraw/getWithdraw',// TODO:
  '/pro/invitation/reward/project-source',// TODO:
  '/attr/t/invitation/reward/getRewardList',// TODO:
  '/attr/a/coin/introduction/getDetail',
  '/attr/a/marketcondition/getDepth',
  '/attr/a/marketcondition/getKline',
  '/attr/a/marketcondition/getDeals',
  '/attr/a/marketcondition/getTickers',
  '/attr/a/marketcondition/getTickersAndKlineList',
  '/attr/a/marketcondition/getTickersAndKline',
  '/attr/t/listenkey',
  '/attr/t/spot/asset/cards',
  '/attr/t/spot/asset/cost/update',
  '/attr/t/spot/tpsl/current',
  '/attr/t/spot/tpsl/history',
  '/attr/t/spot/tpsl/detail',
  '/attr/t/spot/tpsl/create',
  '/attr/t/spot/tpsl/update',
  '/attr/t/spot/tpsl/cancel',
  '/attr/t/lm/order/cancelOrder',
  '/attr/t/lm/order/updateOrder',
  '/attr/t/fund/userfund',
  '/attr/t/fund/bill/getBalanceBills',
  '/attr/t/fund/bill/getOtcBalanceBills',
  '/attr/a/tradepairs/getAllSymbols',
  '/attr/a/tradepairs/getCoinList',
  '/attr/a/tradepairs/getSymbolDetail',
  '/attr/a/tradepairs/getList',
  '/attr/a/coins/getCoinsConfig',
  '/attr/a/coins/pics',
  '/attr/a/coins/getList',
  '/attr/a/conf/fund/spot',
  '/attr/a/conf/fund/otcBalanceBillTypes',
  '/attr/t/deposit/withdraw/getList',
  '/attr/t/deposit/withdraw/progress',
  '/attr/t/withdraw/checkAddress',
  '/attr/t/wallet/userTransfer',
  '/attr/t/wallet/getTransferList',
  '/pro/c2c/pay-method/account/list',
  '/pro/c2c/pay-method/account/bind',
  '/pro/c2c/pay-method/account/update',
  '/pro/c2c/pay-method/account/unbind',
  '/pro/c2c/order/buy',
  '/pro/c2c/order/sell',
  '/pro/c2c/order/list',
  '/pro/c2c/order/cancel',
  '/pro/c2c/order/reply/list',
  '/pro/c2c/order/reply/create',
  '/pro/c2c/order/pay',
  '/pro/c2c/order/finish',
  '/pro/c2c/order/detail',
  '/pro/c2c/agreement/sign/status',
  '/pro/c2c/agreement/sign',
  '/pro/c2c/support/coin/list',
  '/pro/c2c/store/list',
  '/pro/c2c/store/fast/list',
  '/pro/c2c/store/info',
  '/pro/c2c/store/info/update',
  '/pro/c2c/store/info/add',
  '/pro/c2c/store/order/list',
  '/pro/c2c/store/order/unfinished/list',
  '/pro/c2c/store/order/finish',
  '/pro/c2c/store/order/pay',
  '/pro/c2c/store/all',
  '/pro/pay/order/create',
  '/pro/pay/order/list',
  '/pro/pay/order/confirm',
  '/pro/foundation/add',
  '/pro/foundation/list',
  '/pro/newperson/add',
  '/pro/foundation/user/order/list',
  '/pro/foundation/getFoundationText',
  '/pro/purchase/list',
  '/pro/purchase/detail',
  '/pro/purchase/user/info',
  '/pro/purchase/user/order/list',
  '/pro/purchase/join',
  '/pro/node/getList',
  '/pro/pay/order/code/list/v1',
  '/attr/a/marketcondition/getTicker',
  '/attr/a/noticelist',
  '/attr/a/getFunctionUrl',
  '/attr/a/getBannerList',
  '/attr/t/collection/getCollectionList', //
  '/attr/t/collection/addCollect', //
  '/attr/t/collection/cancelCollect', //
  '/attr/t/invitation/reward/getRewardTotal', // 累计返佣金额/
  '/pro/u/znx/list',
  '/attr/t/mail/readZnxMessage',
  '/attr/t/mail/getAllZnxMessage',
  '/attr/t/mail/readAllZnxMessage',
];

const ucUrlArrays = [
  '/lv/need/t/user/loginLog',
  '/lv/need/t/user/logout',
  '/lv/need/t/user/accountCancellation',
  '/lv/common/a/register',
  '/lv/common/a/sendMsg',
  '/lv/need/t/sendLoginMsg',
  '/lv/common/a/geetestInit',
  '/lv/need/t/user/getinfos',
  '/lv/need/t/user/vip/rates',
  '/lv/need/t/user/vip/thresholds',
  '/lv/need/t/user/vip/upgrade-progress',
  '/lv/need/t/user/vip/migration-trial-card/apply',
  '/lv/need/t/user/vip/recharge-trial-card/apply',
  '/lv/need/t/getKfToken',
  '/lv/common/a/check/version',
  '/lv/common/a/have/name',
  '/lv/common/a/login/first',
  '/lv/common/a/reset/first',
  '/lv/common/a/reset/second',
  '/attr/a/media/url',
  '/attr/a/telegram/url',
  '/lv/common/a/getCountryCodeList',
  '/uc/user/get/ticket',
  '/lv/common/a/login/second',
  '/lv/need/t/getGoogleAuthCode',
  '/lv/need/t/user/idesntityAuth',
  '/lv/need/t/file/upload',
  '/lv/need/t/user/urllist',
  '/uc/FoundationInviteReward/getList',
  '/uc/user/profile/update',
  '/uc/user/openlever/update',
  '/lv/need/t/user/findInviteCode',
  '/lv/need/t/apiUser/addUserApi',
  '/lv/need/t/apiUser/updateUserApi',
  '/uc/u/apiUser/update',
  '/lv/need/t/apiUser/deleteUserApi',
  '/lv/need/t/apiUser/listUserApi',
  '/lv/need/t/user/invited/count',
  '/lv/need/t/user/invited/info',
  '/lv/need/t/user/changePassword',
  '/lv/need/t/sendLoginMsg',
  '/lv/need/t/user/security/enableSecurity',
  '/uc/user/pair/collection/list', //
  '/uc/user/pair/collection/add',
  '/uc/user/pair/collection/remove',
  '/uc/poster/list',
  '/uc/user/is-login',
  '/lv/need/t/user/security/verifyGoogle',
  '/lv/need/t/user/security/verifyPhone',
  '/lv/need/t/user/security/verifyEmail',
  '/lv/need/t/user/changePassword',
  '/lv/need/t/user/getSiteUser',
];
const otcUrlArrays = [
  '/foreign/advert/getMerchantInfo',
  '/foreign/user/setReceipt',
  '/foreign/advert/getMyList',
  '/foreign/advert/createAdvertising',
  '/foreign/advert/publishAdvertising',
  '/foreign/advert/updateAdvertising',
  '/foreign/advert/soldOut',
  '/foreign/commons/upload',
  '/foreign/advert/delete',
  '/foreign/order/getOrderInfo/v2',
  '/foreign/order/getList',
  '/foreign/order/confirmPayment',
  '/foreign/order/confirmReceipt',
  '/foreign/order/cancelOrder',
  '/foreign/advert/supportCurrency',
  '/foreign/advert/quickOrderConfig',
  '/foreign/advert/quickAdvertising',
  '/foreign/advert/getList',
  '/foreign/advert/advertisingInfo',
  '/foreign/order/createOrderV2',
  '/foreign/order/orderReplyPull',
  '/otc/order/reply/realtime',
  '/foreign/order/reply/orderReplyList',
  '/foreign/order/reply/userCreateReplyTxt',
  '/foreign/order/reply/userCreateReplyImage',
  '/foreign/user/updateReceiptStatus',
  '/foreign/user/getOtcReceipt',
  '/foreign/order/getOrderInfo',
  '/foreign/user/deleteReceipt',
  '/foreign/order/confirmPayment',
  '/foreign/order/confirmReceipt',
  '/foreign/order/cancelOrder',
  '/foreign/order/getMerchantReceipt',
  '/foreign/order/getUnfinishedOrderCount',
  '/foreign/business/addOtcPayee', // 添加收款人
  '/foreign/business/applyOtcMerchant', // 申请商家
  '/foreign/business/checkNickName', // 昵称校验
  '/foreign/business/businessinfo', // 获取商家信息
  '/foreign/business/getPayeeList', // 获取收款人列表
  '/foreign/business/merchantPage', // 商家信息
  '/foreign/business/quitMerchant', // 退出商家
  '/foreign/business/merchantQuitVerify', // 能否退出商家
  '/foreign/business/unbindOtcPayee', // 解绑收款人
  '/foreign/business/upgradeMerchant', // 升级商家
  '/foreign/user/getinfo',
  '/foreign/advert/advertisingInfo',
  '/foreign/balance/getBalanceHistory',
  '/foreign/billType',
  '/foreign/balance/getBillType',
];
const financialUrlArrays = [
  '/api/financial/product/list',
  '/api/current/list',
  '/api/financial/product/purchase',
  '/api/financial/product/detail',
  '/api/rank/list',
  '/api/user/profit/list',
  '/api/current/set-switch',
  '/api/u/wallet/assetSummary',
  '/api/current/in',
  '/api/current/out',
  '/api/current/detail',
  '/api/financial/order/buy-list',
  '/api/financial/order/order-list',
  '/api/financial/income/income-list',
  '/api/current/order-list',
  '/api/current/pledge-detail',
  '/api/current/io-list',
  '/api/current/income-list',
  '/api/transaction/list',
  '/api/transaction/type',
];
// 接口返回的data是null
const dataNull = ['/api/financial/product/purchase', '/api/current/in', '/api/current/out'];
// 这些接口的调用方需要读取成功响应中的 msg 等外层字段。
const fullResponseUrls = ['/lv/need/t/user/getSiteUser'];

axios.interceptors.request.use(config => {
  const data = config.data;
  let headers = config.headers;
  // 语言切换以 localStorage 为当前值；Cookie 可能因域名不同残留旧值。
  let lang = localStorage.getItem('lang') || Cookies.get('lang') || 'en';
  const from = getQuery('from');
  // 从URL中获取参数
  if (device.isFromApp()) {
    lang = getQuery('lang') || models.account.lang || lang || 'en';
  }

  const sign = config.url?.includes('/attr/t/withdraw/create')
    ? encryptSignWithdraw(new Date().getTime())
    : encryptSign(new Date().getTime());
  // application/json 和 form-data格式参数避过stringify
  const dontNeedStringFy = data instanceof FormData || headers['Content-Type'] === 'application/json';

  // if (token) {
  //   // headers.Authorization = `Bearer ${token}`;
  //   headers['Authorization-ft'] = token;
  // } else {
  //   Reflect.deleteProperty(headers, 'Authorization-ft');
  // }
  headers['Authorization'] = Cookies.get('token');
  headers['platform'] = 'web';
  headers['version'] = '1.0.0';
  headers['lang'] = lang;
  headers['sign'] = sign;
  headers['asi_uuid'] = getUuid();
  headers['user_info'] = JSON.stringify({ version: '1.0.0', platform: 'web', asiUuid: 'getUuid()' });
  headers['device-info'] = getDeviceInfoHeader();

  if (config.dataType === 'file') {
    const _data = new FormData();
    _data.append('file', data.file.originFileObj);
    _data.append('id', data.id);
    headers = Object.assign(headers, {
      'Content-Type': 'multipart/form-data',
    });
    return {
      ...config,
      data: _data,
      headers,
    };
  }
  const isPriceAlertApi = typeof config.url === 'string' && (config.url.startsWith('/attr/t/price-alert/') || config.url === '/attr/t/mail/push/alert/preference');
  if (isPriceAlertApi || proUrlArrays.includes(config.url as string)) {
    return {
      ...config,
      data: dontNeedStringFy ? data : qs.stringify(data),
      headers,
    };
  }
  if (ucUrlArrays.includes(config.url as string)) {
    return {
      ...config,
      data: dontNeedStringFy ? data : qs.stringify(data),

      headers,
    };
  }

  if (otcUrlArrays.includes(config.url as string)) {
    return {
      ...config,
      data,

      headers,
    };
  }
  if (financialUrlArrays.includes(config.url as string)) {
    return {
      ...config,
      data,

      headers: { ...headers, platform: 'web' },
    };
  }
  // if (process.env.NODE_ENV === 'development') {
  //   headers['xt-validate-uid'] = '110';
  // }

  return {
    ...config,
    // 项目仅支持 U 本位，未显式指定 baseURL 时统一走 /next/f
    baseURL: config.baseURL ? `/next${config.baseURL}` : '/next/f',
    data: dontNeedStringFy ? data : qs.stringify(data),
    headers,
  };
});

axios.interceptors.response?.use(
  response => {
    const { data, config } = response;

    // futures 结构： { returnCode, result, msgInfo, error }, 错误详情：error.msg
    // 现货结构：{ code, data, msg， msgInfo } 错误详情：msgInfo.template
    // app-doc 结构：{ code, msg, msgInfo, data }
    const { returnCode, result, msgInfo, code, data: resData, msg } = data;

    // 业务 code 非 0 时优先按失败处理（避免网关同时带 returnCode:0 时被当成成功）
    if (code !== undefined && code !== 0) {
      if (code === 401 || code === 403) {
        if (process.env.NODE_ENV !== 'development') {
          Cookies.remove('token', { domain: getMainDomain(), path: '/' });
          Cookies.remove('token');
          sessionStorage.removeItem('listenKey');
          window.location.reload();
        }
      }
      if ([-10024, -10021, -10022, -10023, -10025, -10026, -10027].includes(code)) {
        return Promise.resolve(data);
      }

      return Promise.reject({ returnCode: code, result: resData ?? result, msgInfo: msg ?? msgInfo, error: msg ?? msgInfo, code });
    }

    // 合约api
    if (returnCode !== undefined) {
      if (returnCode === 0 || code === 0) {
        return Promise.resolve(result);
      }
      return Promise.reject(data);
    }
    if (code !== undefined) {
      // 现货api（此处 code 已为 0）
      if (fullResponseUrls.includes(config.url as string)) {
        return Promise.resolve(data);
      }
      if (dataNull.includes(config.url as string)) {
        return Promise.resolve(true);
      }
      if (resData == null) {
        return Promise.resolve(true);
      }
      return Promise.resolve(resData);
    }

    return Promise.reject({ result: resData, msgInfo: msg });
  },
  error => {
    const history = createBrowserHistory();
    if (axios.isCancel(error)) {
      // 取消导致的错误，不应将cancel置空;
      return Promise.reject(new Error('Request Canceled!'));
    }
    const { response } = error;

    if (response) {
      const { status } = response;

      if (status === 401 || status === 403) {
        Cookies.remove('token', { domain: getMainDomain(), path: '/' });
        Cookies.remove('token');
        Cookies.remove('ws-token');
        sessionStorage.removeItem('listenKey');
        window.location.reload();
        window.location.href = '/login';
        // history.push('/login'); // TODO:注释重新登录
        // history.go();
        Notification.error({
          message: '请重新登陆',
          offset: 60,
          duration: 2000,
        });

        if (process.env.NODE_ENV !== 'development') {
          Cookies.remove('token', { domain: getMainDomain(), path: '/' });
          Cookies.remove('token');
          Cookies.remove('ws-token');
          sessionStorage.removeItem('listenKey');
          window.location.reload();

          window.location.href = '/login';
        }
      } else {
        // TODO
      }

      return Promise.reject(error);
    }
    // TODO: 网络异常
    return Promise.reject(error);
  },
);
